
import { Button } from "../../../components/ui/Button";
import { Dialog, DialogContent } from "../../../components/ui/Modal";
import { useNavigate } from "react-router-dom";
import { useDeliveryFlowStore } from "../../../store/newVehicleDeliveryStore";
import { useEntryBooking} from "../../../hooks/react-query/useVehicleDelivery";
import { validateResponse } from "../deliveryUtils";
import { SpinnerIcon } from "../../../icons";
import { useMemo, useState } from "react";
import { toast } from "sonner";
import { useServiceCarStore } from "../../../store/serviceCarStore";

export const BookingInitButton = ({ disabled, carInfo, deliveryInfo }) => {
  // LOCAL STATE:
  const [openDriversModal, setOpenDriversModal] = useState(false);

  const { setCarInfo } = useServiceCarStore();
 
  // DATA:
  // const { carInfo } = useServiceCarStore();

  // LOCAL VARIABLES:
  const navigate = useNavigate();
  const setUiStep = useDeliveryFlowStore((s) => s.setUiStep);
  const setCarData = useDeliveryFlowStore((s) => s.setCarData);
  const reset = useDeliveryFlowStore((s) => s.reset);
  const setCarPlateno = useDeliveryFlowStore((s) => s.setCarPlateno);
  const setDeliveryCosts = useDeliveryFlowStore((s) => s.setDeliveryCosts);
  const setApiOptions = useDeliveryFlowStore((s) => s.setApiOptions);
  const setSelectedOption = useDeliveryFlowStore((s) => s.setSelectedOption);
  const setIsVehicleDeliverySelected = useDeliveryFlowStore((s) => s.setIsVehicleDeliverySelected);
  const setFlowId = useDeliveryFlowStore((s) => s.setFlowId);
  const setFlowStep = useDeliveryFlowStore((s) => s.setFlowStep);
  const setHasVehicleHomeDelivery = useDeliveryFlowStore((s) => s.setHasVehicleHomeDelivery);
  const setHasOnlyCalendar = useDeliveryFlowStore((s) => s.setHasOnlyCalendar);
  const setBookingCalendarOptions = useDeliveryFlowStore((s) => s.setBookingCalendarOptions);
  const setSelectedCalendarOption = useDeliveryFlowStore((s) => s.setSelectedCalendarOption);
  const setDeliveryLocation = useDeliveryFlowStore((s) => s.setDeliveryLocation);
  

  const {mutateAsync: enterBooking, isLoading: isEnterBookingLoading} = useEntryBooking()

  // FETCH DATA:

  // USE EFFECTS:
  // useEffect(() => {
  //   if (carInfo.plateno === undefined) {
  //     navigate(-1);
  //   }
  // }, [carInfo, navigate]);

  const deliveryType = useMemo(()=>{
    if(!!deliveryInfo?.currentlyAllowed){
      return "NEW WAY"
    } else {
      if(deliveryInfo?.deliveryLocation?.garageCategory === "Vehicle Delivery - Επαρχία") {
        return "RAC"
      } else if (deliveryInfo?.deliveryLocation?.garageCategory === "Vehicle Delivery - Dealers") {
        return "AUTHORIZED"
      } else {
        return null
      }
    }
  },[deliveryInfo])


  // HANDLERS & FUNCTIONS
  const handleNewService = async () => {
    reset()
    setCarData(carInfo)
    setCarInfo(carInfo)
    setCarPlateno(!!carInfo?.vehPlate ? carInfo?.vehPlate : carInfo?.plateno)
    setHasVehicleHomeDelivery(!!deliveryInfo?.hasHomeDelivery)
    const payload = {
      plateno: !!carInfo?.vehPlate ? carInfo?.vehPlate : carInfo?.plateno,
    };
    // if(deliveryType==="NEW WAY"){
    if(deliveryType==="NEW WAY"){
      try{
        const response = await enterBooking({payload:payload})
        const isResponseValid = validateResponse(response)
        if(isResponseValid) {
          setFlowId(response?.id)
          setDeliveryLocation({address:deliveryInfo?.deliveryLocation?.address, city:deliveryInfo?.deliveryLocation?.city, googleMapsURL:deliveryInfo?.deliveryLocation?.googleMapsURL, garageCategory:deliveryInfo?.deliveryLocation?.garageName})
          if(!!deliveryInfo?.hasHomeDelivery){
            setApiOptions(response?.inputs?.optionSelection?.options)
            setSelectedOption(response?.inputs?.optionSelection?.options?.includes("HomeDelivery") ? "HomeDelivery" : "GarageDelivery")
            setIsVehicleDeliverySelected(response?.inputs?.optionSelection?.options?.includes("HomeDelivery") ? true : false)
            setDeliveryCosts(response?.vehicleDeliveryCosts)
          } else if (!deliveryInfo?.hasHomeDelivery) {
            setApiOptions("GarageDelivery")
            setSelectedOption("GarageDelivery")
            setIsVehicleDeliverySelected(false)
            setHasOnlyCalendar(true)
            setDeliveryCosts(null)
            const bookingCalendarOptions = response?.inputs?.bookingCalendar?.options?.map((option) => {return {startTime: option?.StartTime, endTime:option?.EndTime}})
            // set New State based on the response
            setBookingCalendarOptions(bookingCalendarOptions)
            setSelectedCalendarOption({selectedDate:null, selectedSlots:[]})
          }
          setFlowStep(response?.name)
          setUiStep(1);
          navigate(`/vehicledelivery?deliveryType=${deliveryType}`)
        } else {
          toast({
            variant: 'destructive',
            description: response?.exceptions?.plateno?.[0] ?? "Προέκυψε κάποιο σφάλμα",
          });
        }
      } catch(e) {
        console.warn(e)
      }
    } else {
      setUiStep(10);
      !!deliveryType && navigate(`/vehicledelivery?deliveryType=${deliveryType}`)
    }

    // if (carInfo?.actions?.find((item) => item?.name === "booking").enabled) {
    // } else setOpenDriversModal(true);
  };

  return (
    <>
      <Button
        className="w-full p-3 text-sm text-white font-bold bg-[#D4002A] rounded-md flex gap-2 items-center justify-center"
        disabled ={disabled}
        onClick={handleNewService}
      >
        <p className={`text-label font-bold ${disabled && 'text-fadedgrey'} max-lg:text-[#D4002A]`}>Κλείσε ραντεβού</p>
        {isEnterBookingLoading && <SpinnerIcon className="w-4 h-4 fill-white" />}
      </Button>

      {/* BUSSINESS RULE: A client cannot book a delivery if no drivers are set to the specific car */}
      {/* Dialog shows on button clicked and if there are no drivers set in the car. */}
      <Dialog
        open={openDriversModal}
        onOpenChange={(open) => setOpenDriversModal(open)}
      >
        <DialogContent>
          <div className="bg-white rounded-[12px] p-10 gap-6 flex flex-col items-center">
            <h3>Απαιτείται προσθήκη οδηγού</h3>
            <p className="text-body">
              Για να προγραμματίσεις ραντεβού παραλαβής, θα πρέπει να
              προσθέσεις τουλάχιστον έναν οδηγό στο αυτοκίνητο.
            </p>
            <Button
              onClick={() => {
                setOpenDriversModal(false);
              }}
              className={"rounded-[6px] bg-[#D4002A] py-3 px-10 text-white h6"}
            >
              Κλείσιμο
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
